import type { Translate } from 'types'

export function getReturnsHeaders(translate: Translate) {
  return [
    translate('revenue.details.result.number'), // Icon
    translate('revenue.revenue'),
    translate('revenue.details.result.sharePerStore'),
  ]
}

export function getGeneralHeaders(translate: Translate) {
  return [
    null, // Icon
    translate('revenue.details.result.sale'),
    translate('returnsValueDetails.returns'),
    translate('revenue.details.result.saleWithoutReturns'),
  ]
}
